import { Box, styled } from '@mui/material';

export const SettingsPagePane = styled(Box)(({ theme }) => ({
  height: 'calc(100vh - 120px)',
}));
